import { Location, LocationContext, navigate } from '@reach/router';
import { ROUTE_MAP } from 'components/app/routeMap';
import { GameLoaderBridge } from 'components/gameLoaderBridge';
import Header from 'components/header';
import React, { Component } from 'react';
import { Dialogs } from 'shared/dialogs';
import Nav from 'shared/nav';
import { Routes } from './routing';
import { Layout } from '@nackle/paper';
import auth from 'app/auth';
import { swapPathCompanyId } from 'routes/paths';
import { AppHeader, AppFooter} from '@nackle/studio-tools';
import NackleMenu from '@nackle/menu';
import { getNavigationBundle } from 'app/dux/session/selectors';
import { setLanguageBundle } from '@nackle/intl-tools';
export default class App extends Component {
     state = {
         cmxBundleLoaded: false,
         authDelegate: false
    };

    componentDidMount(){
        getNavigationBundle().then(bundle => {
            setLanguageBundle('en-US', bundle.bundles['en-US']);
            this.setState({
                cmxBundleLoaded: true
            });
        });

        const match = window.location.pathname.match(/company\/([^/]+)/);

        if (match) {
            auth.delegate(match[1])
                .then(() => {
                    this.setState({
                        authDelegate: true
                    });
                })
                .catch(error => console.log(error));
        }
     }

    render () {
        const {cmxBundleLoaded} = this.state;

        return (
            <Location>
                {() => {
                    // The <Location> component will refresh this bit whenever the path changes.
                    const match = window.location.pathname.match(/company\/([^/]+)/);

                    if (!match) {
                        // RootRedirectToCompany hasn't happened yet.
                        return <div/>;
                    }

                    const companyId = match[1];

                    return (
                        <Layout className="root-layout">
                            <AppHeader
                                companyId={companyId}
                                onCompanyChange={this.handleCompanyClick}
                                auth={auth}
                            />
                            <Layout>
                                <NackleMenu
                                    auth={auth}
                                    cmxBundleLoaded={cmxBundleLoaded}
                                    collapsible={true}
                                />
                                <Layout>
                                    <Layout.Content className="app-content">
                                        <Header />

                                            <div className="container-fluid">

                                                <Location>{({ location }: LocationContext) => <Nav path={location.pathname} />}</Location>

                                                <Routes routes={ROUTE_MAP} />

                                            </div>

                                            <GameLoaderBridge/>

                                            <Dialogs />
                                    </Layout.Content>
                                    <AppFooter/>
                                </Layout>
                            </Layout>
                        </Layout>
                    );
                }}
            </Location>
        );
    }
    private handleCompanyClick = async (company: any) => {
        await auth.delegate(company.id);
        navigate(swapPathCompanyId(location.pathname, company.id));
    };
}
